import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import type { ApplicationList } from 'types/api'
import type { BaseResponse } from 'types/utils'

export const applicationsQueryKey = ['applications']

interface UseApplicationArgs {
  // TODO: check if search works
  search?: string
  limit?: number
  offset?: number
}

export function useApplications({ search, limit }: UseApplicationArgs) {
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    if (search) {
      params.set('search', search)
    }
    if (limit !== undefined) {
      params.set('limit', limit.toString())
    }
    params.set('status', 'True')

    return params
  }, [search, limit])

  async function getApplications() {
    const url = `${SNA_PREFIX}applications?${queryParams.toString()}`
    const response = await apiClient.get<BaseResponse<ApplicationList>>(url)
    return response.data
  }

  return useQuery({
    queryFn: getApplications,
    queryKey: [...applicationsQueryKey, queryParams.toString()]
  })
}
